export enum MetamaskErrorCodes {
  "NO_METAMASK_PLUGIN" = "NO_METAMASK_PLUGIN",
  "NO_WALLET_CONNECTED" = "NO_WALLET_CONNECTED",
  "WALLET_DISCONNECTED" = "WALLET_DISCONNECTED",
}
